export const Dolby = () => {
    return (
        <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.0449219 3C0.0449219 2.44772 0.492637 2 1.04492 2H21.0449C21.5972 2 22.0449 2.44772 22.0449 3V17C22.0449 17.5523 21.5972 18 21.0449 18H1.04492C0.492638 18 0.0449219 17.5523 0.0449219 17V3ZM3.04492 5H5.04492C7.80635 5 10.0449 7.23858 10.0449 10C10.0449 12.7614 7.80635 15 5.04492 15H3.04492V5ZM17.0449 5H19.0449V15H17.0449C14.2835 15 12.0449 12.7614 12.0449 10C12.0449 7.23858 14.2835 5 17.0449 5Z"
                fill="white"
            />
        </svg>
    );
};
